module.exports = __webpack_public_path__ + "img/img3.3778a62e.png";